import React from "react";
import {
    Route,
    Routes,
} from "react-router-dom";
import { Box } from '@mui/material';
import style from "./style";
// component
import Sidebar from "../../components/sideBar";
// pages
import Applicationform from "../../pages/applicationForm";
import Login from "../../pages/login";
import Error from "../../pages/error";
import Dashboard from "../../pages/dashboard";
import Users from "../../pages/users";
import Register from "../../pages/register";
import Dependents from '../../pages/dependents';
import ForgotPassword from "../../pages/forgotPass";
import ResetPassword from "../../pages/resetPassword";
import Reports from "../../pages/reports"
import SingleUser from "../../pages/singleUser";
import SingleDependent from "../../pages/singleDependent";
import ApprovedApplication from "../../pages/approvedApplications/ApprovedApplications";
import PendingApplications from "../../pages/pendingApplications/PendingApplications";
import PendingMasavApplications from "../../pages/pendingMasavApps";
import RejectedApplications from "../../pages/rejectedApplications/RejectedApplications";
import FinshedApplications from "../../pages/finishedApplications/FinishedApplications";
// import SingleApplication from "../../pages/singleApplication"
import Categories from "../../pages/categories";
import SingleCategory from "../../pages/singleCategory";
import SingleApplicationWrap from "../../pages/singleApplicationWrap/SingleAppLicationWrap";
import MasavExportsArchive from "../../pages/masavExportsArchive";
import UploadMasavConfirmation from "../../pages/uploadMasavConfirmation";
import SingleMasavExport from "../../pages/singleMasavExport";
import Messages from "../../pages/messages/Messages";




function Layout() {

    return (
        <Box sx={style.root}>
            <>

                <Sidebar />
                <Box
                    sx={{
                        ...style.content
                    }}
                >


                    <Routes>
                        <Route path="/" element={<Applicationform />} />
                        <Route path="/dashboard" element={<Dashboard />} />
                        <Route path="/register" element={<Register />} />
                        <Route path="/dependents" element={<Dependents />} />
                        <Route path="/dependents/:id" element={<SingleDependent />} />
                        <Route path="/users" element={<Users />} />
                        <Route path="/users/:id" element={<SingleUser />} />
                        <Route path="/applications/pending" element={<PendingApplications />} />
                        <Route path="/applications/approved" element={<ApprovedApplication />} />
                        <Route path="/applications/pending-masav" element={<PendingMasavApplications />} />
                        <Route path="/applications/rejected" element={<RejectedApplications />} />
                        <Route path="/applications/finished" element={<FinshedApplications />} />
                        <Route path="/applications/:status/:id" element={<SingleApplicationWrap />} />
                        <Route path="/masav-exports" element={<MasavExportsArchive />} />
                        <Route path="/masav-exports/:id/upload" element={<UploadMasavConfirmation />} />
                        <Route path="/masav-exports/:id" element={<SingleMasavExport />} />
                        <Route path="/messages" element={<Messages />} />
                        <Route path="/forgot-password" element={<ForgotPassword />} />
                        <Route path="/reset-password/:guid" element={<ResetPassword />} />
                        <Route path="/reports" element={<Reports />} />
                        <Route path="/categories" element={<Categories />} />
                        <Route path="/categories/:id" element={<SingleCategory />} />
                        <Route path="login" element={<Login />} />
                        <Route path="*" element={<Error />} />

                    </Routes>

                </Box>
            </>
        </Box>
    );
}

export default Layout